export const autoCompleteStyles = { width: '100%' }
